<template>
  <div v-if="showBanner" class="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6">
    <div class="max-w-7xl mx-auto bg-gray-800 rounded-2xl shadow-2xl border border-gray-700 p-6 md:p-8">
      <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <!-- Content -->
        <div class="flex-1">
          <div class="flex items-start space-x-4">
            <div class="flex-shrink-0">
              <svg class="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-semibold text-white mb-2">
                {{ $t('cookies.title') }}
              </h3>
              <p class="text-gray-300 text-sm md:text-base mb-2">
                {{ $t('cookies.message') }}
              </p>
              <router-link to="/privacy" class="text-primary text-sm underline">
                {{ $t('cookies.learnMore') }}
              </router-link>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          <button
            @click="rejectCookies"
            class="px-6 py-3 text-sm font-medium text-gray-200 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors duration-200 whitespace-nowrap"
          >
            {{ $t('cookies.reject') }}
          </button>
          <button
            @click="acceptCookies"
            class="px-6 py-3 text-sm font-medium text-white bg-primary hover:bg-primary-dark rounded-lg transition-colors duration-200 whitespace-nowrap"
          >
            {{ $t('cookies.accept') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const showBanner = ref(false)

const COOKIE_CONSENT_KEY = 'heidelbell_cookie_consent'

onMounted(() => {
  // Check if user has already made a choice
  try {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    console.log('Cookie consent check:', consent)
    if (!consent) {
      // Show banner after a small delay for better UX
      setTimeout(() => {
        showBanner.value = true
        console.log('Cookie banner shown:', showBanner.value)
      }, 500)
    } else {
      console.log('Cookie consent already set, not showing banner')
    }
  } catch (error) {
    // If localStorage is not available, show the banner anyway
    console.warn('localStorage not available:', error)
    setTimeout(() => {
      showBanner.value = true
      console.log('Cookie banner shown (localStorage error):', showBanner.value)
    }, 500)
  }
})

const acceptCookies = () => {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
  } catch (error) {
    console.warn('Could not save cookie consent:', error)
  }
  showBanner.value = false
  // You can add analytics or other cookie-dependent features here
  console.log('Cookies accepted')
}

const rejectCookies = () => {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected')
  } catch (error) {
    console.warn('Could not save cookie consent:', error)
  }
  showBanner.value = false
  // You can disable analytics or other cookie-dependent features here
  console.log('Cookies rejected')
}
</script>

<style scoped>
/* Animation for banner appearance */
.fixed {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>

